import { useEffect, useState } from "react";
import api from "../lib/apiClient";

const ACTION_BADGE = {
  create: "bg-emerald-100 text-emerald-800",
  update: "bg-blue-100 text-blue-800",
  delete: "bg-red-100 text-red-800",
  send_email: "bg-purple-100 text-purple-800",
  invite: "bg-amber-100 text-amber-900",
  change_role: "bg-slate-100 text-slate-700",
};

export default function AuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit-log?limit=200").then(({ data }) => setItems(data)); }, []);
  return (
    <div data-testid="audit-log-page" className="space-y-6">
      <div><h1 className="font-display text-3xl font-bold tracking-tight">Audit Log</h1><p className="text-sm text-slate-500 mt-1">Who changed what, when. Admin only.</p></div>
      <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 dark:bg-slate-800 text-slate-500 text-[11px] uppercase">
            <tr><th className="px-4 py-3 text-left">When</th><th className="px-4 py-3 text-left">Who</th><th className="px-4 py-3 text-left">Action</th><th className="px-4 py-3 text-left">Entity</th><th className="px-4 py-3 text-left">Details</th></tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-500">No audit entries yet.</td></tr>}
            {items.map((it) => (
              <tr key={it.id} className="border-t border-slate-100 dark:border-slate-800">
                <td className="px-4 py-3 text-slate-600 text-xs whitespace-nowrap">{new Date(it.created_at).toLocaleString("en-CA", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</td>
                <td className="px-4 py-3 text-slate-700">{it.user_email || "—"}</td>
                <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded ${ACTION_BADGE[it.action] || "bg-slate-100 text-slate-700"}`}>{it.action}</span></td>
                <td className="px-4 py-3 text-slate-700">{it.entity_type} <span className="text-xs text-slate-400">· {(it.entity_id || "").slice(0, 8)}</span></td>
                <td className="px-4 py-3 text-xs text-slate-500"><pre className="font-mono whitespace-pre-wrap max-w-md">{it.meta ? JSON.stringify(it.meta) : ""}</pre></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
